import {Button} from 'antd';
import React from 'react';

import {STRINGS} from '../../libs/ui/src/index';
import {CloseOutlined} from "@ant-design/icons";

export function MobileWarning({onClose}) {
  return (
    <div className="mobile-app-warning">
      <Button onClick={onClose} icon={<CloseOutlined/>} ghost shape="circle" style={{color: 'white'}} />
      {STRINGS.warning.mobile_warning}
    </div>
  );
}
